module.exports = __webpack_public_path__ + "img/reports--icon.7655c613.svg";